import { render, staticRenderFns } from "./AllShops.vue?vue&type=template&id=0a61bae3&scoped=true&"
import script from "./AllShops.vue?vue&type=script&lang=js&"
export * from "./AllShops.vue?vue&type=script&lang=js&"
import style0 from "./AllShops.vue?vue&type=style&index=0&id=0a61bae3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a61bae3",
  null
  
)

export default component.exports